<ng-container [ngSwitch]="dialogueKey">
  <div class="dialogue-status-container" *ngSwitchCase="dailyReflectionKeys.includes(dialogueKey) ? dialogueKey : ''">
    <ng-container *ngIf="dataStatus?.status === status.done && dialogueStatusData; else dialogueShimmer">
      <h1 class="greeting-dialogue" *ngIf="dialogueStatusData[dialogueKey]?.todayMessage">
        {{ dialogueStatusData[dialogueKey]?.todayMessage }}
      </h1>
      <kp-dialogue
        *ngIf="dataStatus?.data?.dialogueStatus === dialogueStatus.not_started; else reflectionNotEmbedded"
        [isEmbedded]="true"
        [returnUrl]="returnUrl"
        [dialogueLogicKey]="dialogueKey"></kp-dialogue>
      <ng-template #reflectionNotEmbedded>
        <a
          *ngIf="
            dialogueStatusData[dialogueKey]?.buttonText && dataStatus?.data?.dialogueStatus !== dialogueStatus.completed
          "
          routerLink="/dialogue"
          [queryParams]="{ key: dialogueKey, returnUrl: returnUrl }"
          class="button-dialogue">
          {{ dialogueStatusData[dialogueKey]?.buttonText }}
          <svg-icon src="assets/icons/chevron-right-nocircle.svg"></svg-icon>
        </a>
      </ng-template>
    </ng-container>
  </div>
  <ng-container *ngSwitchCase="dialogueLogicKey.dialogue_purposeful_onboarding_v1">
    <kp-dialogue
      [isEmbedded]="false"
      [returnUrl]="returnUrl"
      [dialogueLogicKey]="dialogueKey"
      title="Onboarding"></kp-dialogue>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <kp-dialogue [isEmbedded]="false" [returnUrl]="returnUrl" [dialogueLogicKey]="dialogueKey"></kp-dialogue>
  </ng-container>
</ng-container>
<div class="error" *ngIf="dataStatus?.status === status.error">There was an error retrieving this content.</div>

<ng-template #dialogueShimmer>
  <!-- Ensure this matches the shimmer in the dialogue component so as to not have different shimmers when dialogue is embedded -->
  <!-- Embedded dialogues now have a different size than normal dialogues so check for ng-deep if shimmers don't match -->
  <kp-shimmer class="dialogue-shimmer"></kp-shimmer>
  <kp-shimmer class="dialogue-shimmer"></kp-shimmer>
  <kp-shimmer class="dialogue-button-shimmer"></kp-shimmer>
</ng-template>
